<template>
  <div class="hStack"
       :style="{'flex-wrap':flexWrap, 'justify-content': justifyContent,'align-items': alignItems, 'flex-direction':flexDirection}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'hStack',
  props: {
    justifyContent: {
      type: String,
      default: 'center'
    },
    alignItems: {
      type: String,
      default: 'center'
    },
    flexDirection: {
      type: String,
      default: 'row'
    },
    flexWrap: {
      type: String,
      default: 'nowrap'
    }
  }
}
</script>

<style lang="scss" scoped>

.hStack {
  display: flex;
}

.hStack::-webkit-scrollbar {
  height: 0 !important;
}

</style>
